import AttachFilesBlockControl from './AttachFilesBlockControl';

export default AttachFilesBlockControl;
